import { putUserSetting } from "@/js/api.schema";

export const STUDY_SUMMARY_SETTING_KEY = "show_study_summary_panel";
export const LEGACY_STUDY_SUMMARY_SETTING_KEY = "show_study_summary_insights";

export const isStudySummaryEnabled = () => {
  const raw = process.env.BACKEND_ENABLED_FEATURES__STUDY_SUMMARY;
  if (raw == null) return true;
  return String(raw).toUpperCase() === "TRUE";
};

export const persistStudySummaryPanelSetting = value =>
  putUserSetting(STUDY_SUMMARY_SETTING_KEY, value).catch(err =>
    console.error("Failed to save setting:", err)
  );

export const applyStudySummaryUserSettings = (store, data) => {
  if (!isStudySummaryEnabled()) {
    store.commit("studySummary/setShowPanel", false);
    return;
  }
  if (!data) return;
  if (data[STUDY_SUMMARY_SETTING_KEY] !== undefined) {
    store.commit("studySummary/setShowPanel", data[STUDY_SUMMARY_SETTING_KEY]);
    return;
  }
  if (data[LEGACY_STUDY_SUMMARY_SETTING_KEY] !== undefined) {
    store.commit("studySummary/setShowPanel", data[LEGACY_STUDY_SUMMARY_SETTING_KEY]);
  }
};
